<template>
  <div class="page-wrapper" style="position: fixed; top:0; left:0; width: 100%; height: 100%; padding-top:0; color: #555; overflow-y: auto;">

    <div v-if="bookingItem != false" class="container">
      <div class="row">
        <div class="col-12" style="padding-top: 20px; font-weight: bold; font-size: 20px;">
          Your Reservation #{{bookingItem.id}}
        </div>
        <div class="col-12" v-if="merchantItem !== false" style="font-weight: bold; font-size: 15px;">
          {{merchantItem.title}}
          <br>
          {{merchantItem.address}}
          <br>
          {{merchantItem.contact}}
        </div>
      </div>
      <div class="row" style="margin-top: 20px;font-weight: bold; font-size: 18px;">
        <div class="col-12" v-if="bookingItem.state === 0">
          Waiting for confirmation from restaurant
        </div>
        <div class="col-12" v-if="bookingItem.state === 5">
          Waiting for your confirmation. Please click accept or reject for new schedule.
          <br>
          <button class="btn btn-success">ACCEPT</button> <button class="btn btn-danger">DANGER</button>
        </div>
        <div class="col-12" v-else-if="bookingItem.state === 10">
          Confirmed
        </div>
        <div class="col-12" v-else-if="bookingItem.state < 0" style="color: red;">
          Cancelled
        </div>
      </div>

      <div class="row booking-form-row text-left">

        <div class="col-12 col-md-4">
          Date
          <input v-if="bookingItem.edit === false" class="form-control text-left" v-model="bookingItem.bookingDate" disabled/>
          <date-picker v-else style="width: 100%; height: 38px; line-height: 38px;" v-model="bookingItem.bookingDate" typable="false" placeholder="Select Date" valueType="format" @change="onBookingDateSelected"></date-picker>
          <!--        <input class="form-control" type="date" v-model="bookingItem.bookingDate" v-on:change="onBookingDateSelected"></input>-->
        </div>
        <div class="col-12 col-md-4">
          Time
          <input v-if="bookingItem.edit === false" class="form-control text-left" v-model="bookingItem.bookingDayTime" disabled/>
          <select v-else class="form-control" v-model="bookingItem.bookingTime" :disabled="!bookingItem.edit">
            <option value="0">Select Time</option>
            <option v-if="bookingItem.slots.length > 0" v-for="slot in bookingItem.slots" :value="slot.time" :disabled="slot.available === false">{{slot.text}}  {{slot.available === false?' Full':''}}</option>
          </select>
        </div>

        <div class="col-12 col-md-4" v-if="bookingItem.types !== null && bookingItem.types.length > 0">
          Booking Type:
          <label class="form-control">{{bookingItem.types.join(',')}}</label>
        </div>
        <div class="col-12 col-md-4">
          Number of people
          <select class="form-control" v-model="bookingItem.headCount" :disabled="!bookingItem.edit">
            <option value="0">Number of people</option>
            <option v-for="(c, ci) in 20" :value="c">{{c}} People</option>
          </select>
        </div>
        <div class="col-12 col-md-4">
          Name
          <input class="form-control" type="text" v-model="bookingItem.name" placeholder="Name" :disabled="!bookingItem.edit">
        </div>
        <div class="col-12 col-md-4">
          Contact
          <input class="form-control" type="text" v-model="bookingItem.contact" placeholder="Mobile Number" :disabled="!bookingItem.edit">
        </div>
        <div class="col-12 col-md-4">
          Email
          <input class="form-control" type="text" v-model="bookingItem.email" placeholder="Email" :disabled="!bookingItem.edit">
        </div>
        <div class="col-12 text-left">
          Special Request
          <textarea class="form-control" rows="3" v-model="bookingItem.note" :disabled="!bookingItem.edit"/>
        </div>
<!--        <div class="col-12 text-right" v-if="canSubmitBooking() == true">-->
<!--          <button class="btn btn-dark" v-on:click="submitBooking">Submit</button>-->
<!--        </div>-->
        <div class="col-12 text-left" v-if="bookingItem.authorisedAmount > 0 && bookingItem.paid === 0 && bookingItem.authorisationCancelled !== true">
          <strong>Deposit £{{(bookingItem.authorisedAmount/100.0).toFixed(2)}} authorised {{getTimeString(bookingItem.authorisedTime)}}</strong>
        </div>
        <div class="col-12 text-left" v-if="bookingItem.paid > 0 && bookingItem.authorisationCancelled !== true">
          <strong>Paid £{{(bookingItem.paid/100.0).toFixed(2)}} on {{getTimeString(bookingItem.paidTime)}}</strong>
        </div>
        <div class="col-12 text-left" v-if="bookingItem.authorisationCancelled === true">
          <strong>Deposit Cancelled on {{getTimeString(bookingItem.authorisationCancelledTime)}}</strong>
        </div>
      </div>
      <div class="row" style="margin-top: 20px;font-weight: bold; font-size: 18px;">

        <div class="col-12" v-if="bookingItem.state >= 0">
          If you want to cancel this reservation, click button below
          <br/>
          <div v-if="bookingItem.cancellableTime > 0">
            You can cancel before {{getTimeString(bookingItem.cancellableTime)}} <span v-if="bookingItem.authorisedAmount > 0"> without charge of £{{(bookingItem.authorisedAmount/100.0).toFixed(2)}}</span>
          </div>
          <button class="btn btn-danger" v-on:click="cancelBooking">CANCEL RESERVATION</button>
        </div>
      </div>

    </div>
    <div class="container web-section" v-if="merchantItem != false">
      <div class="row">
        <div class="col-12 col-md-4">
          <div class="webpage-section-header  text-center" >
            Contact Us
          </div>
          <div class="place-bottom-container">
            <i class="fas fa-map-marker"></i> <a :href="'http://maps.google.com/?q=' + merchantItem.address" target="_blank" >{{merchantItem.address}}</a>
            <br>
            <i class="fas fa-phone"></i> <a :href="'tel:' + merchantItem.contact">{{merchantItem.contact}}</a>
            <!--            <span v-if="merchantItem.distance != undefined"><i class="fas fa-map-marker"></i> {{Number(merchantItem.distance).toFixed(1)}} miles</span>-->
          </div>
        </div>
        <div class="col-12 col-md-4">
          <!--                <div class="round-box" style="margin:auto;">-->
          <div class="webpage-section-header text-center">
            Opening Hours
          </div>
          <div class="body">
            <table>
              <tr v-for="(day, di) in openingTime">
                <td style="width: 50%; vertical-align: top;">{{day.dayString}}</td>

                <td style="width: 50%; vertical-align: top; text-align: left;">
                  <template v-if="day.open==false">
                    Closed
                  </template>
                  <template v-if="day.open == true && day.times != undefined && day.times.length > 0">
                    <span v-for="(time, ti) in day.times"><span v-if="ti>0">, </span>{{time.from}}~{{time.to}}</span>

                  </template>
                </td>

              </tr>
            </table>
          </div>
          <!--                </div>-->
        </div>
        <div class="col-12 col-md-4">
          <div class="webpage-section-header  text-center">
            Location
          </div>
          <div style="height: 300px;" id="mapName">
            <iframe :src="merchantItem.webSetting.googleMap" width="100%" height="100%" frameborder="0" style="border:0"
                    allowfullscreen></iframe>
          </div>
        </div>
      </div>
    </div>
    <v-dialog/>
  </div>
</template>

<script>
  import {cancelBookingItem, getBookingItem, getMerchant, getBookingSlots} from "../api/borium";
  import {millisToDate} from "../api/utils";
  import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/index.css';
    export default {
      name: "MyBooking",
      components: {
        DatePicker
      },
      data() {
        return {
          merchantItem: false,
          bookingItem:false,
          message:false,
          openingTime:[],
        }
      },
      created() {
        this.initialise();
      },
      mounted() {
      },
      beforeDestroy() {
      },
      destroyed() {
      },
      methods: {
        showDialog: function(message, title = '') {
          let params = {
            title:title,
            text:message
          }
          this.$modal.show('dialog', params);
        },
        getTimeString: function(time) {
          return new Date(time).toLocaleString();
        },
        initialise: function() {
          if (this.$route.params.hasOwnProperty("id") === false || this.$route.query.hasOwnProperty("itemToken") === false) {
            this.$data.message = "Unavailable";
            return;
          }

          let self = this;
          getBookingItem(this.$route.params.id, this.$route.query.itemToken)
          .then(function(data) {
            // console.log(data);
            if(data.success === true) {
              data.item.edit = false;
              self.$data.bookingItem = data.item;
              self.getMerchantItem(data.item.subscriptionId);
            } else {
              self.$data.message = data.message;
            }
          })
          .catch(function(err) {

          })

        },
        getMerchantItem: function(merchantId) {
          let self = this;
          getMerchant(merchantId)
            .then(function(data) {
              // console.log(data);
              if(data.success) {
                if(data.item.webSetting !== undefined && data.item.webSetting !== null) {
                  if(data.item.webSetting.imageUrls !== undefined && data.item.webSetting.imageUrls !== null && data.item.webSetting.imageUrls.length > 0) {
                    data.item.webSetting.imageUrls = data.item.webSetting.imageUrls.split(",");
                  } else {
                    data.item.webSetting.menuImages = [];
                  }
                  if(data.item.webSetting.menuImages !== undefined && data.item.webSetting.menuImages !== null && data.item.webSetting.menuImages.length > 0) {
                    data.item.webSetting.menuImages = data.item.webSetting.menuImages.split(",");
                  } else {
                    data.item.webSetting.menuImages = [];
                  }
                }
                self.$data.merchantItem = data.item;
                if(self.$data.merchantItem.openingTime != null && self.$data.merchantItem.openingTime.length > 3) {
                  self.$data.openingTime = JSON.parse(self.$data.merchantItem.openingTime);
                }
                // self.setMerchant();
              }
            })
            .catch(function(err) {
              // console.log(err);
            })
        },
        onBookingDateSelected: function() {
          if(this.$data.bookingItem.bookingDate === undefined || this.$data.bookingItem.bookingDate === null
            || this.$data.bookingItem.bookingDate === '' || this.$data.bookingItem.bookingDate === '0000-00-00') {
            this.$data.bookingItem.bookingDate = null;
            return false;
          }
          this.$data.bookingItem.slots = [];
          this.$data.bookingItem.bookingTime = 0;
          this.loadLondonSlots();
        },
        loadLondonSlots: function() {
          let self = this;
          getBookingSlots(this.merchantItem.merchantId, this.$data.bookingItem.bookingDate, this.$data.bookingItem.bookingType)
            .then(function(data) {
              if(data.success !== true || data.item == null) {
                self.$data.bookingItem.bookingDate = null;
                self.$data.bookingItem.slots = [];
                self.showDialog(data.message || "This date is not available");
                return;
              }
              self.$data.bookingItem.slots = (data.item && data.item.slots) ? data.item.slots : [];
            })
            .catch(function(err) {
              console.error('Request failed', err && err.response ? err.response.status : '');
              self.$data.bookingItem.bookingDate = null;
              self.showDialog("There was an error. Please try again.");
            })
        },
        cancelEdit: function() {
          this.initialise();
        },
        changeDateTime: function() {

        },
        cancelBooking: function() {
          let self = this;
          this.$modal.show('dialog', {
            title:"CANCEL RESERVATION",
            text:"Do you want to cancel this reservation?",
            buttons:[
              {
                title: '<strong><span style="font-size:1.2rem;">NO</span></strong>',
                handler: () => {
                  self.$modal.hide('dialog');

                }
              },
              {
                title: '<strong><span style="font-size:1.2rem;">YES</span></strong>',
                handler: () => {
                  self.$modal.hide('dialog');
                  self.processCancellation();

                }
              },
            ]
          });
        },
        processCancellation: function() {
          let self = this;
          cancelBookingItem(this.$route.params.id, this.$route.query.itemToken)
          .then(function(data) {
            if(data.success === true) {
              self.initialise();
            } else {
              self.showDialog(data.message);
            }
          })
          .catch(function(err) {
            self.showDialog("Sorry, there is an error. Please try in a moment", "ERROR");
          })
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/MyBooking.vue